import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { Icon, useTheme } from '@ui-kitten/components';
import { Dayjs } from 'dayjs';

import constants from '../../../Config/constants';
import themeColor from '../../../Theme/colors';
import themeStyle from '../../../Theme/styles';
import breakpoints from '../../../Theme/styles/breakpoints';

import Button from '../../Button';
import { textCategory } from '../../Reservation/constants';
import ResponsiveText from '../../ResponsiveText';

type TimeItemProps = {
  description: string;
  disabled?: boolean;
  value: Dayjs;
  onProceed: (time: string) => void; // time is DBTIME_FORMAT
};

const TimeItem = ({
  description,
  disabled,
  value,
  onProceed,
}: TimeItemProps) => {
  const theme = useTheme();
  const formatedTime = value?.format?.(constants.DBTIME_FORMAT);
  return (
    <View
      style={[
        themeStyle.flexDirectionRowCenter,
        styles.border,
        { borderColor: theme['color-info-500'] },
      ]}
    >
      <View dataSet={{ media: ids.textContainer }} style={styles.textContainer}>
        <ResponsiveText
          category={textCategory.XSMALL_BODY}
          style={themeStyle.spacingRightMedium}
        >
          {value.format(constants.TIME_ONLY_DISPLAY_CAPITAL_FORMAT)}
        </ResponsiveText>
        <ResponsiveText
          appearance="hint"
          category={textCategory.XSMALL_BODY}
          numberOfLines={1}
          style={[themeStyle.flex1, themeStyle.textCenter]}
        >
          {description}
        </ResponsiveText>
      </View>
      <Button
        onPress={() => onProceed(formatedTime)}
        style={styles.btn}
        disabled={disabled}
        plain
      >
        <View
          style={[
            themeStyle.flex1,
            themeStyle.justifyContentCenter,
            themeStyle.pageVerticalSpacingSmall,
            themeStyle.pageHorizontalSpacingSmall,
            { backgroundColor: theme['color-info-500'] },
          ]}
        >
          <Icon name="checkmark" fill={themeColor.white} style={styles.icon} />
        </View>
      </Button>
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  border: {
    borderWidth: 1,
    borderRadius: 10,
    overflow: 'hidden',
  },
  btn: {
    alignSelf: 'stretch',
  },
  textContainer: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRowCenter,
    ...themeStyle.pageVerticalSpacingMedium,
    ...themeStyle.pageHorizontalSpacing,
    [`@media ${breakpoints.xs}`]: {
      ...themeStyle.pageHorizontalSpacingSmall,
    },
  },
  icon: {
    width: 25,
    height: 25,
  },
});

export default TimeItem;
